module.exports = __webpack_public_path__ + "media/images/icons/icon_basket-a2967a1d8949808446dfa56533afa6f8.png";